import { MessageChannel } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";
import { getMessageSequence } from "@/app/actions/messages-content/steps/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  objectiveId?: number;
  channel: MessageChannel;
  enabled?: boolean;
};

export function buildMessageSequenceQueryKey(
  objectiveId: number | undefined,
  channel: MessageChannel,
) {
  return [QueryKey.MESSAGE_SEQUENCE, objectiveId, channel];
}

export function useFetchMessageSequence(options: Options) {
  const { objectiveId, channel, enabled = true } = options;

  return useQuery({
    queryKey: buildMessageSequenceQueryKey(objectiveId, channel),
    queryFn: () => getMessageSequence(objectiveId!, channel),
    enabled: enabled && !!objectiveId,
    staleTime: Infinity,
  });
}
